import { toast } from 'react-toastify';

const CopyToClipBoard = ({ link, children }) => {
    const handleCopyLink = () => {
        navigator.clipboard.writeText(link)
            .then(() => {
                toast.info('Copied to clipboard!');
            })
            .catch((err) => {
                toast.error('Failed to Copy');
            });
    };

    return (
        <span>
            {children ?? link}
            <span
                onClick={handleCopyLink}
                className="mdi mdi-content-copy ms-1 ml-1"
                style={{ cursor: 'pointer' }}
            />
        </span>
    );
};

export default CopyToClipBoard;
